import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { MyOptionsPage as MyOptionsPageTS } from "../../../options/pages/MyOptionsPage";
import { connect } from "react-redux";

const MyOptionsPage = ({id, isGhosting}) => {

    return (
      <Container fluid>
        <Row>
          <Col>
            <MyOptionsPageTS employeeId={id} isGhosting={isGhosting} />
          </Col>
        </Row>
      </Container>
    );

}

function mapStateToProps(state)
{
  const profile = state.profile;
  return profile.ghost ? { id: profile.ghost, isGhosting: true } : { id: profile.employeeId, isGhosting: false };

}

export default connect(mapStateToProps)(MyOptionsPage);